/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { getIsMarketingContactsSku } from 'pricing-pages-lib/utils/productsUtils';
import { useSelector } from 'react-redux';
import { CONTACT, MARKETING_CONTACT_DEPRECATED, USER } from 'self-service-api/constants/UnitTypes';
import Small from 'UIComponents/elements/Small';
import UILink from 'UIComponents/link/UILink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { useState, useEffect } from 'react';
import { skuSelector, quantityPackForProductVersionSelector } from '../../../selectors/ProductsSelectors';
import { usePricingLibSelector } from '../../../selectors/SelectorUtils';
import { AsyncContactsPriceBreakdownModal } from '../../common/contacts-price-breakdown/AsyncContactsPriceBreakdownModal';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';

const IncludedUnitsSubtext = ({
  skuId,
  className,
  trackingSource,
  style = {},
  queryParamTerm,
  productConfigurations
}) => {
  const [priceBreakdownVisible, setPriceBreakdownVisible] = useState(false);
  useEffect(() => {
    if (priceBreakdownVisible) {
      getUsageTracker().track('clickToViewModal', {
        name: 'contact-picker-more-details-modal',
        location: trackingSource
      });
    }
  }, [priceBreakdownVisible]);
  const quantityPackSkuId = useSelector(state => {
    if (!skuId) return null;
    const quantityPack = quantityPackForProductVersionSelector(state, {
      productVersionSkuId: skuId
    });
    return quantityPack && quantityPack.skuId;
  });
  const {
    quantityUnit: {
      unitType,
      includedWithProductVersion
    }
  } = useSelector(state => skuSelector(state, {
    skuId: quantityPackSkuId
  }));
  const isMarketingContactsSku = usePricingLibSelector(state => getIsMarketingContactsSku(state, {
    skuId
  }));
  if (!unitType) return null;
  let stringKey;
  let messageProps = {
    elements: {
      Number: FormattedNumber
    },
    options: {
      value: includedWithProductVersion
    }
  };

  if (unitType === USER) {
    stringKey = 'pricingPage.highlightedMerchCards.includes.usersStartsAt_jsx';
  } else if (unitType === CONTACT || unitType === MARKETING_CONTACT_DEPRECATED) {
    if (isMarketingContactsSku) {
      stringKey = 'pricingPage.highlightedMerchCards.includes.contactsMCStartsAt_jsx';
      messageProps = {
        elements: {
          Number: FormattedNumber,
          Link: UILink
        },
        options: {
          onClick: () => setPriceBreakdownVisible(true),
          onMouseEnter: () => AsyncContactsPriceBreakdownModal.preload(),
          value: includedWithProductVersion
        }
      };
    } else {
      stringKey = 'pricingPage.highlightedMerchCards.includes.contactsStartsAt_jsx';
    }
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [priceBreakdownVisible && /*#__PURE__*/_jsx(AsyncContactsPriceBreakdownModal, {
      quantityPackSkuId: quantityPackSkuId,
      marketingContactsSelected: includedWithProductVersion,
      handleModalClose: () => setPriceBreakdownVisible(false),
      productConfigurations: productConfigurations,
      queryParamTerm: queryParamTerm
    }), /*#__PURE__*/_jsx("div", {
      className: className,
      style: style,
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        className: "m-right-2",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
          message: stringKey
        }, messageProps))
      })
    })]
  });
};

export default IncludedUnitsSubtext;